<template lang="pug">
    li(
        :class="{ visible: active, hover: focused }"
        @mouseover="hover"
        @mouseleave="blur"
    )
        .tree-item
            a(v-if="item.page && item.page.view === 'Logout'" @click="signout") {{ item.title }}
            router-link(v-else :to='item.path') {{ item.title }}
            button(
                v-if="toggleEvent === 'click' && children && children.length && ( ! maxDepth || depth < maxDepth)"
            )
                i.is-open(v-if="active" @click="close")
                i.is-closed(v-else @click="open")
        tree-menu(
            v-if="children.length && ( ! maxDepth || depth < maxDepth)"
            :items="children" :depth="depth + 1" :max-depth="maxDepth"
            :show="active"
        )

</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'TreeMenuItem',
    data() {
        return {
            timeout: undefined,
            visible: false,
            mouseover: false,
        }
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        depth: {
            type: Number,
            required: true,
        },
        maxDepth: {
            type: Number,
        },
        toggleEvent: {
            type: String,
            required: true,
        },
        current: {
            type: Object,
        },
        delay: {
            type: Number,
            required: true,
        },
        allowMultipleActiveItems: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        active() {
            if (this.allowMultipleActiveItems === true) return this.visible
            return this.visible && this.current && this.item.id === this.current.id
        },
        focused() {
            if (this.allowMultipleActiveItems === true) return this.mouseover
            return this.mouseover && this.current && this.item.id === this.current.id
        },
        children() {
            let children = []
            if (this.item.children && this.item.children.length) {
                children = this.item.children.filter(item => {
                    let visible = true

                    if (item.restriction === 'members' && ! this.isAuthenticated) visible = false
                    else if (item.restriction === 'guests' && this.isAuthenticated) visible = false
                    if (item.disabled) visible = false

                    return visible
                })
            }

            return children
        },
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated',
        }),
    },
    methods: {
        hover() {
            if (this.timeout) clearTimeout(this.timeout)
            if (this.toggleEvent === 'hover') {
                this.$emit('focus', this.item)
                this.visible = true
            }
            this.mouseover = true
        },
        blur() {
            this.timeout = setTimeout(() => {
                if (this.toggleEvent === 'hover') {
                    this.$emit('blur', this.item)
                    this.visible = false
                }
                this.mouseover = false
            }, this.delay);
        },
        open() {
            if (this.toggleEvent === 'click') {
                this.$emit('open', this.item)
                this.visible = true
            }
        },
        close() {
            if (this.toggleEvent === 'click') {
                this.$emit('close', this.item)
                this.visible = false
            }
        },
        ...mapActions({
            signout: 'auth/signout',
        })
    }
}
</script>

<style lang="sass" scoped></style>
